<template>
    <div>
        <div v-if="showFormSuccess && !dismissAlert" class="alert-success">
            Successfully updated license!
            <span @click="clearAlert()"><md-icon class="fa fa-times-circle light link"></md-icon></span>
        </div>
        <h2>Licenses</h2>
        <LicenseTable class="table-padding" :action-button-callback="showCreateAdminLicense" :license-type="'ADMIN'" :show-search="true" :licenses="licenses" :refresh-licenses="refreshLicenses" :success-cb="didCreateLicense"></LicenseTable>
        <md-dialog class="invite-admin-modal" :md-active="showCreateAdminLicenseModal">
            <md-dialog-title class="modal-title">Create New License</md-dialog-title>

            <LicenseForm :form-type="'create'" :success-cb="didCreateLicense" :license-type="'ADMIN'" :non-editable-fields="null"></LicenseForm>
            <md-dialog-actions>
                <md-button class="md-accent" @click="showCreateAdminLicenseModal = false">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import LicenseTable from './LicenseTable'
import LicenseForm from './LicenseForm'

export default {
    name: 'AdminLicenses',
    components: {
        LicenseTable,
        LicenseForm
	},
    data() {
        return {
            licenses: null,
            showCreateAdminLicenseModal: false,
            showFormSuccess: false,
            dismissAlert: false
        }
    },
    methods: {
        ...mapActions([
            'fetchAdminLicenses'
        ]),
        clearAlert() {
            this.showFormSuccess = false;
			this.dismissAlert = true;
		},
        closeDialog() {
            this.showCreateAdminLicenseModal = false;
            this.showFormSuccess = true;
        },
        didCreateLicense() {
            this.dismissAlert = false;
            this.closeDialog();
            this.refreshLicenses();
        },
        async refreshLicenses() {
            this.licenses = await this.fetchAdminLicenses();
        },
        showCreateAdminLicense() {
            this.showCreateAdminLicenseModal = true;
        }
    },
    async created() {
        await this.refreshLicenses();
    }
}
</script>

<style scoped>
.table-padding {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 80px;
}
.invite-admin-modal {
    overflow-y: scroll;
    width: 70vw;
}
.modal-title {
    text-align: center;
}
.alert {
    text-align: center;
    margin-left: 1em;
    margin-right: 1em;
}
.alert-success {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: var(--btn-primary-color);
    color: white;
    display: inline-block;
    padding-left: 20px;
    padding-right: 20px;
}
</style>
